const newsItem = (json) => ({
  "id": json["id"] || "",
  "username": json["username"] || "",
  "date": json["date"] || "",
  "title": json["title"] || "",
  "content": json["content"] || "",
  "commentCount": json["comment_count"] || 0,
});

export default newsItem;